import { useQuery } from '@tanstack/react-query';
import { buscarDadosPadrao, type DadosPadrao } from '@/lib/dadosPadraoApi';

/** O que o lead trouxe e o que sabemos; depois completa operadora, WhatsApp e AchaTudo do que falta. */
export function useDadosPadrao(leadId: string | null | undefined) {
  const rapido = useQuery({
    queryKey: ['dados-padrao', leadId],
    enabled: !!leadId,
    staleTime: 5 * 60_000,
    queryFn: (): Promise<DadosPadrao | null> => buscarDadosPadrao(leadId as string, false),
  });
  const completo = useQuery({
    queryKey: ['dados-padrao', leadId, 'completo'],
    enabled: !!leadId && !!rapido.data?.camada1,
    staleTime: 30 * 60_000,
    retry: false,
    queryFn: (): Promise<DadosPadrao | null> => buscarDadosPadrao(leadId as string, true),
  });
  return { data: completo.data ?? rapido.data, isLoading: rapido.isLoading, completando: completo.isFetching };
}
